module.exports = __webpack_public_path__ + "themes/mf/img/prize-6@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-6@2x.png
// module id = 97
// module chunks = 3